var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.699,
    height: 21.7,
    viewBox: "0 0 19.699 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 19.699,
    height: 21.7,
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M18.85,4H14.7V2.851A2.853,2.853,0,0,0,11.85,0h-4A2.853,2.853,0,0,0,5,2.851V4H.85a.851.851,0,0,0,0,1.7H2v13.15A2.853,2.853,0,0,0,4.85,21.7h10a2.853,2.853,0,0,0,2.849-2.85V5.7H18.85a.851.851,0,0,0,0-1.7M6.7,2.851A1.152,1.152,0,0,1,7.85,1.7h4A1.151,1.151,0,0,1,13,2.851V4H6.7Zm9.3,16A1.152,1.152,0,0,1,14.85,20h-10A1.152,1.152,0,0,1,3.7,18.851V5.7H16Z",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M7.85,9A.85.85,0,0,0,7,9.85v6a.85.85,0,0,0,1.7,0v-6A.85.85,0,0,0,7.85,9",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M11.85,9a.85.85,0,0,0-.85.85v6a.85.85,0,0,0,1.7,0v-6A.85.85,0,0,0,11.85,9",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBin);
export default __webpack_public_path__ + "static/media/LightBin.b6927120161a7e6dd66ea2954845cc9c.svg";
export { ForwardRef as ReactComponent };